export default __webpack_public_path__ + "static/media/Illustration3.b2ebbe04.png";